import * as Yup from 'yup'
import i18n from '../../i18n'
import { VALIDATION } from '../../utils/translation-constants'

export const LoanSchema = Yup.object().shape({
  loanAmount: Yup.number().min(1, i18n.t(VALIDATION.GREATER)).required(i18n.t(VALIDATION.LOANAMOUNT)),
  loanTenure: Yup.number()
    .min(0, i18n.t(VALIDATION.TENUREVALID))
    .required(i18n.t(VALIDATION.TENURE)),
  loanInterestRate: Yup.number()
    .min(0, i18n.t(VALIDATION.INTEREST_RATEVALID))
    .required(i18n.t(VALIDATION.INTERESTRATE)),
})

export const DepositSchema = Yup.object().shape({
  depositAmount: Yup.number().min(1, i18n.t(VALIDATION.GREATER)).required(i18n.t(VALIDATION.DEPOSITEAMOUNT)),
  depositTenure: Yup.number()
    .min(0, i18n.t(VALIDATION.TENUREVALID))
    .required(i18n.t(VALIDATION.TENURE)),
  depositInterestRate: Yup.number()
    .min(0, i18n.t(VALIDATION.INTEREST_RATEVALID))
    .required(i18n.t(VALIDATION.INTERESTRATE)),
})
